export default function About() {
  return (
    <section className="py-24 px-6 bg-gradient-to-b from-black via-zinc-950 to-black">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Left: Image */}
          <div className="relative">
            <div className="absolute inset-0 bg-red-600/20 blur-3xl"></div>
            <img
              src="https://static.readdy.ai/image/f2e9d0ecb0c8da9b7a5f1d855b73822d/4bac12e55af01d7f1ba6afcc0beda814.png"
              alt="E.T.C Portrait"
              className="relative w-full h-auto object-cover object-top shadow-2xl"
            />
          </div>

          {/* Right: Bio */}
          <div>
            <h2 className="text-5xl md:text-6xl font-black mb-6 text-white">
              THE VISION
            </h2>
            <div className="space-y-4 text-gray-300 text-lg leading-relaxed">
              <p>
                <strong className="text-red-500">E.T.C—Eric The Centaur—</strong>is a Chicago creative who's spent his entire life building worlds. From finger-painting on Mario Paint as a kid to mastering graphic design, fashion, photography, videography, and A.I.-driven visual art, his mind operates like a designer's: every frame intentional, every emotion curated.
              </p>
              <p>
                Music is his latest evolution—not a pivot, but a continuation. For decades, melodies lived in his head with no outlet. Now, powered by A.I. and years of creative direction, E.T.C finally has the tools to manifest the sound he's always carried.
              </p>
              <p>
                Musically, he exists in the intersection of <strong className="text-white">Kanye's innovation, Rocky's cool mystique, Virgil's cultural vision, and Billie's haunting intimacy</strong>—but darker, sharper, more current.
              </p>
              <p className="text-red-400 font-semibold">
                Think DJ Khaled's creative director energy, but with a personal voice and emotional depth.
              </p>
              <p>
                His songs explore modern masculinity, love's complications, ambition from nothing, loyalty, and the quiet storms men carry in silence.
              </p>
              <p className="italic text-gray-400 border-l-4 border-red-600 pl-4">
                "Art isn't a hobby—it's a lifelong compulsion. And this? This is just the beginning."
              </p>
            </div>

            <div className="mt-8 flex flex-wrap gap-3">
              <span className="px-4 py-2 bg-red-600/20 border border-red-600 text-red-400 text-sm font-semibold">CHICAGOLAND-RAISED</span>
              <span className="px-4 py-2 bg-red-600/20 border border-red-600 text-red-400 text-sm font-semibold">VISION-DRIVEN</span>
              <span className="px-4 py-2 bg-red-600/20 border border-red-600 text-red-400 text-sm font-semibold">GENRE-FLUID</span>
              <span className="px-4 py-2 bg-red-600/20 border border-red-600 text-red-400 text-sm font-semibold">TIMELESS</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
